import * as React from 'react';
import useDeepCompareEffect from 'use-deep-compare-effect';

import { useAppSelector } from '@/redux/hooks';
import { getCuratedCollectionItemIds } from '@/redux/modules/curatedCollection';
import { getItemSummaries } from '@/redux/modules/item/summary/itemSummary.selectors';
import { sortItems } from '@/redux/modules/sorting';

const useGetSortedCollectionItemIds = (sort: string): number[] => {
    const itemIds = useAppSelector(getCuratedCollectionItemIds);
    const items = useAppSelector((state) => getItemSummaries(state, itemIds));
    const sortedItemIds = sortItems(items, sort).map(({ itemId }) => itemId);
    const itemRef = React.useRef<number[]>(sortedItemIds);

    useDeepCompareEffect(() => {
        itemRef.current = sortedItemIds;
    }, [sortedItemIds]);

    return itemRef.current;
};

export default useGetSortedCollectionItemIds;
